import React from 'react'
import { Modal } from 'components/Modal'
import { DataTable } from 'components/DataTable'
import listHistory from './listHistory'
import formatDate from 'helpers/dateTimeFormatter'

const columns = [{
	Header: 'Datum',
	accessor: 'timestamp',
	width: 150,
	Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY HH:mm:ss')
}, {
	Header: 'Operation',
	accessor: 'operation'
}, {
	Header: 'Benutzername',
	width: 110,
	accessor: 'userName'
}, {
	Header: 'Feld',
	width: 120,
	accessor: 'fieldName'
}, {
	Header: 'Alter Wert',
	width: 160,
	accessor: 'oldValue'
}, {
	Header: 'Neuer Wert',
	width: 160,
	accessor: 'newValue'
}, {
	Header: 'Inhalt',
	accessor: 'content',
	Cell: ({ value }) => value ? value : '-'
}, {
	Header: 'Art',
	accessor: 'formName'
}, {
	Header: 'Fieldname in DB',
	accessor: 'dbFieldName'
}, {
	Header: 'DBFieldType',
	accessor: 'dbFieldType'
}, {
	Header: 'NewValueID',
	accessor: 'newValueID',
	Cell: ({ value }) => value ? value : '-'
}]

const HistoryModel = ({ unmount, recordId, sectionData, appData }) => {
	return (
		<Modal
			width={900}
			unmount={unmount}
			label='Verlauf'
		>
			<DataTable
				columns={columns}
				height={600}
				remoteOptions={{
					query: listHistory,
					variables: {
						language: appData.language,
						type: sectionData.typename,
						recordId
					}
				}}
			/>
		</Modal>
	)
}

export default HistoryModel
